import React from 'react'
import { Params, Routes, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import SignIn from '../../../../pages/public/authentication/SignIn'
import SignUp from '../../../../pages/public/authentication/signUp/SignUpFlow'
import PasswordRecovery from '../../../../pages/public/authentication/PasswordRecovery'
import PageNotFound from '../../GlobalPages/PageNotFound'
import createRoute from './createRoute'

export interface routerType {
    title: string
    path: string
    element: JSX.Element
}

interface UrlParams {
    env: string
    distributor: string
    route: string
}

const getParamsFromUrl = (params: Readonly<Params<string>>): UrlParams => {
    const url = Object.values(params)[0].split('/')

    return {
        env: url[0],
        distributor: url[1],
        route: url[2],
    }
}

const PublicNavigation = () => {
    const navigate = useNavigate()
    const params = useParams()
    const { search } = useLocation()
    const { env } = getParamsFromUrl(params)

    if (["food-service", "retail"].includes(env)) {
        navigate(`/${search ? search : ""}`)
    }

    return <Routes>{createRoute(publicpages)}</Routes>
}

export default PublicNavigation

const publicpages: routerType[] = [
    {
        path: '/',
        element: <SignIn />,
        title: 'signin',
    },
    {
        path: 'signup',
        element: <SignUp />,
        title: 'signup',
    },
    {
        path: 'recovery',
        element: <PasswordRecovery />,
        title: 'recovery',
    },
    {
        path: '*',
        element: <PageNotFound />,
        title: '*',
    },
]
